<template>
    <div class="club-step">
        <div class="club-step__main">
            <div class="club-step__confirmed">
                <p class="fancy-title">Confirmed</p>
                <p class="club-step__thanks">Thank you, {{ getMemberFirstName }}</p>
                <div
                    class="club-step__wine-selection__list"
                    v-if="getActiveCatalog"
                >
                    <div
                        class="club-step__wine-selection-item"
                        v-for="item in getActiveCatalog.WineItems"
                        :key="`wine-${item.ID}`"
                    >
                        <div v-if="item.Quantity > 0" class="multiplier">
                            x{{ item.Quantity }}
                        </div>
                        <img
                            v-if="
                                item.Wine.Image &&
                                item.Wine.Image.ID &&
                                item.Wine.Image.URL
                            "
                            :src="item.Wine.Image.URL"
                        />
                        <div v-else class="placeholder"></div>
                        <p class="club-step__wine-selection-item__title">
                            {{ item.Wine.Title }}
                        </p>
                    </div>
                </div>
                <div v-else class="club-step__wine-selection__list">
                    <div
                        class="club-step__wine-selection-item"
                        v-for="item in groupedShipmentWines"
                        :key="`wine-${item.ID}`"
                    >
                        <div v-if="item.Quantity > 0" class="multiplier">
                            x{{ item.Quantity }}
                        </div>
                        <img
                            v-if="
                                item.Wine.Image &&
                                item.Wine.Image.ID &&
                                item.Wine.Image.URL
                            "
                            :src="item.Wine.Image.URL"
                        />
                        <div v-else class="placeholder"></div>
                        <p class="club-step__wine-selection-item__title">
                            {{ item.Wine.Title }}
                        </p>
                    </div>
                </div>
                <div class="club-step__review-summary">
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            My Subscription
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <div class="club-step__membership-unit">
                                <p class="club-step__membership-amount">
                                    {{ getMemberTier.AnnuallyBottles / 4 }}
                                </p>
                                <p class="club-step__membership-amount-text">
                                    Bottles/
                                    <br />quarter
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            My Wines
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p
                                class="club-step__wine-selection-title"
                                v-if="getActiveCatalog"
                            >
                                {{ getActiveCatalog.Title }}
                            </p>
                            <p class="club-step__wine-selection-title" v-else>
                                Custom Selection
                            </p>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            Delivered to
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p v-if="getShippingAddress === null">
                                You have not set your shipping address.
                                <br />
                                Update your details and fill in your address.
                            </p>
                            <div
                                v-else
                                class="club-step__review-summary-item-address"
                            >
                                <p>
                                    {{ getShippingAddress.FirstName }}
                                    {{ getShippingAddress.Surname }}
                                </p>
                                <p>{{ getShippingAddress.Address }}</p>
                                <p>{{ getShippingAddress.City }}</p>
                                <p>
                                    {{ getShippingAddress.State }}
                                    {{ getShippingAddress.PostalCode }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Actions :actions="actions" />
                <!--
                <div class="club-step__actions">
                    <button @click="changeSelection()" class="btn-outline">
                        Change selection
                    </button>
                    <button @click="goToUpdateDetails()" class="btn-secondary">
                        Update details
                    </button>
                    <button @click="goToUpdateBilling()" class="btn-primary">
                        Update billing
                    </button>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Actions from "./components/Actions.vue";
export default {
    name: "Step4",
    components: {
        Actions
    },
    props: {
        member: {
            type: Object,
        },
    },
    mounted() {
        // console.log(member)
        if (this.getActiveCatalog === undefined) {
            console.warn("No catlog set this component will not render");
        }
    },
    data() {
        return {
            actions: [
                {
                    title: "Change wine selection",
                    className: "btn-outline-primary",
                    method: this.changeSelection,
                },
                {
                    title: "Update account details",
                    className: "btn-outline-primary",
                    method: this.goToUpdateDetails,
                },
                {
                    title: "Update credit card",
                    className: "btn-outline-primary",
                    method: this.goToUpdateBilling,
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            "getActiveCatalog",
            "getMemberFirstName",
            "getMemberTier",
            "getShipmentWines",
            "getShippingAddress",
            "getShippingAddressID",
        ]),
        groupedShipmentWines() {
            const w = this.getUniqueWinesWithQuantity(this.getShipmentWines);
            // console.log(w);
            return w;
        },
    },
    methods: {
        ...mapActions(["goToUpdateDetails", "goToUpdateBilling", "setConfigStep"]),
        getUniqueWinesWithQuantity(arr) {
            return Object.values(
                arr.reduce((acc, obj) => {
                    const { ID } = obj;

                    if (ID) {
                        // If the object with the same ID is already in the accumulator, increase the quantity
                        if (acc[ID]) {
                            acc[ID].Quantity += 1;
                        } else {
                            // Otherwise, add the object to the accumulator with Quantity initialized to 1
                            acc[ID] = { ID, Quantity: 1, Wine: obj };
                        }
                    }

                    return acc;
                }, {}),
            );
        },
        changeSelection() {
            this.setConfigStep(0);
        },
    },
};
</script>
